import { Account } from '../../Model/Account';
import { AccountRepository } from '../Repositories/AccountRepository';

export class GetAccountsUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(): Promise<Account[]> {
    return this.repo.getAccounts().then(res => res).catch(err => Promise.reject(err));
  }
}
